// Display/grouping label for an employee's department. Blank/null departments
// are grouped as "Unassigned" — keying an object by a null department
// otherwise produces a department literally named "null".

export const UNASSIGNED_DEPARTMENT = "Unassigned";

export function departmentLabel(department?: string | null): string {
  const trimmed = typeof department === "string" ? department.trim() : "";
  return trimmed || UNASSIGNED_DEPARTMENT;
}

/** Counts per department label, e.g. { Admin: 4, Unassigned: 2 }. */
export function countByDepartment(
  employees: { department?: string | null }[],
): Record<string, number> {
  return employees.reduce((acc: Record<string, number>, emp) => {
    const dept = departmentLabel(emp.department);
    acc[dept] = (acc[dept] || 0) + 1;
    return acc;
  }, {});
}
